function tarjet_button_slider_df() {
    // Select each 'difference' component separately
    const containers = document.querySelectorAll(".difference");

    containers.forEach(container => {
        const tabsDf = container.querySelectorAll('[data-role="tab-df"]');
        const tabContentsDf = container.querySelectorAll(".difference__content");

        tabsDf.forEach(tab => {
            tab.addEventListener("click", () => {
                const target = container.querySelector(tab.dataset.target);
                const active_mode = tab.dataset.mode;

                // Reset only inside this container
                tabContentsDf.forEach(tc => {
                    tc.classList.remove("is-active");
                    tc.classList.remove("is-active-inverse");
                });

                // Activate only the matched tab
                if (target) {
                    target.classList.add(active_mode);
                }

                // Reset active state only for tabs in this container
                tabsDf.forEach(t => t.classList.remove("is-active"));
                tab.classList.add("is-active");
            });
        });
    });
}

tarjet_button_slider_df();
export default tarjet_button_slider_df;